import { createContext } from 'react'

const TabsGroupContext = createContext()

export default TabsGroupContext
